import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, createBlock as _createBlock, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-103c7a2f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "shop-bottom text-rt" }
const _hoisted_2 = {
  key: 0,
  class: "fee"
}
const _hoisted_3 = { class: "fee" }
const _hoisted_4 = {
  key: 1,
  class: "fee"
}
const _hoisted_5 = { class: "color-555" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("： ")
const _hoisted_7 = { class: "red-color" }
const _hoisted_8 = {
  key: 2,
  class: "fee"
}
const _hoisted_9 = { class: "color-555" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("： ")
const _hoisted_11 = { class: "color-555 price2" }
const _hoisted_12 = {
  key: 3,
  class: "fee"
}
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-question cursor-pt" }, null, -1))
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" ：")
const _hoisted_16 = { class: "price" }
const _hoisted_17 = { class: "fee" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-wenhao_tianchong" }, null, -1))
const _hoisted_19 = /*#__PURE__*/_createTextVNode("：")
const _hoisted_20 = { class: "fee" }
const _hoisted_21 = { class: "rr-color" }
const _hoisted_22 = { class: "ml_10 small" }
const _hoisted_23 = { class: "small gray flex-end" }
const _hoisted_24 = { class: "tip" }
const _hoisted_25 = { style: {"margin-top":"7px"} }
const _hoisted_26 = {
  key: 0,
  style: {"flex":"1"},
  class: "agree-btn"
}
const _hoisted_27 = ["innerHTML"]
const _hoisted_28 = { class: "mr_20" }
const _hoisted_29 = { class: "order-num" }
const _hoisted_30 = { class: "rr-color" }
const _hoisted_31 = { class: "ml_10 small" }
const _hoisted_32 = {
  key: 1,
  class: "flex-ter float"
}

import { ref, computed, watch, nextTick } from 'vue'
import { t as _t } from '@/plugins/i18n'
import WatchSticky from '@/components/common/WatchSticky.vue'
import { formatMoney } from '@/plugins/utils'
import { getWallet } from '@/apis/user'
import { defectiveProductRiskFlag, updateProductRisk } from '@/apis/shopcart'
import { getUser, getEffectTermByType, agreeTerm } from '@/apis/login'
import { calc, formatMoneyDirection } from '@/util/useYan'
import { useStore } from 'vuex'
import OpenMember from './OpenMember.vue'
import ExceedingNumTip from './ExceedingNumTip.vue'
import { isD2C, useSite2Station, isKO, isJA, isEN } from '@/store'
import TermModal from '@/components/termModal/index.vue'
import { Term } from '@/common/const'
import dayjs from 'dayjs'
import { getTrueNumber } from '@/util/common'
import { tCurrency, useSourceCountry } from '../country'
import { COUNTRY } from '@/global'


export default /*#__PURE__*/_defineComponent({
  props: [
  'confirm',
  'pdtFee',
  'adtFee',
  'curPdtFee',
  'disabled',
  'isNumberExceed',
  'mode',
  'hiddenGroupBtn',
  'emitSubmit',
  'errorGoods',
  'totalBuyQuantity',
  'combineAdditionTotalFee',
  'showNum'
],
  emits: ['commit', 'createGroup', 'getWallet', 'submit'],
  setup(__props, { emit }) {

const props = __props
const [sourceCountryInfo, change] = useSourceCountry()
// 先转换货币
const t = (str: string) => {
  const ccy = tCurrency(str)
  return ccy ?? _t(str)
}

const stationCode = useSite2Station()
const store = useStore()
// emitSubmit 是否点击支付抛出
// hiddenGroupBtn 是否隐藏组合按钮
// pdtFee 商品预估价格
// adtFee 商品预估附加项价格
// curPdtFee /** 本期支付总金额 */
// curPdRate /** 本期支付总金额比例 */
// falPdRmb /** 尾款支付总金额 */
// falPdRate /** 尾款支付总金额比例 */
// errorGoods 异常商品
// totalBuyQuantity 下单商品总数量
// showNum是否展示勾选商品数量


const pdtRmb = computed(() => formatMoney(props.pdtFee))
const adtRmb = computed(() => formatMoney(props.adtFee))
const curPdtRmb = computed(() => formatMoney(props.curPdtFee))
const curPdRate = computed(() =>
  (
    (props.curPdtFee / props.pdtFee ? props.curPdtFee / props.pdtFee : 0) * 100
  ).toFixed(2)
)
const falPdRmb = computed(() => formatMoney(props.pdtFee - props.curPdtFee))
const falPdRate = computed(() =>
  (props.curPdtFee / props.pdtFee
    ? 100 - (props.curPdtFee / props.pdtFee) * 100
    : 0
  ).toFixed(2)
)

const rmb = computed(() => {
  let price = ''
  if (props.confirm && props.mode === 0) {
    price = formatMoney(props.curPdtFee + props.adtFee)
  } else {
    price = formatMoney(props.pdtFee + props.adtFee)
  }
  return price
})
//

const yan = computed(() => {
  let price: any = ''
  if (props.confirm && props.mode === 0) {
    price = calc(props.curPdtFee + props.adtFee, sourceCountryInfo.value === COUNTRY.KR ? 'KRW' : 'CNY')
  } else {
    price = calc(props.pdtFee + props.adtFee, sourceCountryInfo.value === COUNTRY.KR ? 'KRW' : 'CNY')
  }
  return price
})

const rest = ref('')
const token = store.getters.token

// 是否禁止提交
const disabledBtn = computed(() => {
  return Object.keys(props.errorGoods).length > 0
})
watch(sourceCountryInfo, () => {
  getWallet({
    customerShopId: store.getters.curShop,
    currencyCode: sourceCountryInfo.value === COUNTRY.KR ? 'KRW' : 'CNY'
  }).then((res) => {
    if (res.success) {
      rest.value = formatMoney(res.data.availableAmount)
    }
  })
}, {
  immediate: true
})

watch(
  () => props.isNumberExceed,
  (value: any) => {
    isAgree.value = true
  }
)

watch(
  () => props.mode,
  () => {
    if (!props.mode) isAgree.value = true
  }
)

const isSticky = ref(true)
const isAgree = ref(false)

const argeeVisiable = ref(false) // 是否显示不良品风险提示
const openMemberRef = ref()
const exceedingNumTip = ref()
const termModalRef = ref()
const term = ref()
const catTerm = async () => {
  //
  const res = await getEffectTermByType({
    stationCode,
    type: Term.regular
  })
  term.value = res.data[0]

  // 等待props更新后，在open
  nextTick(termModalRef.value.open)
}
// 提交订单
const submitOrder = () => {
  getUser(token).then((res: any) => {
    if (res.code === '0') {
      // 判断是不是会员
      if (res.data.membership.templateLevel === 0) {
        openMemberRef.value.open()
        return
      }
      if (props.emitSubmit) {
        emit('submit')
        return
      }

      defectiveProductRiskFlag().then((response: any) => {
        if (response.code === '0') {
          if (!response.data) {
            catTerm()
            return
            // argeeVisiable.value = true;
            // riskArgeement.value.sendCode(); // 倒计时 5s
          }
          // 判断是否是经济舱会员并且下单数量超过200件，并且是采购到库存的订单，引导用户开通标准舱会员
          if (
            res.data.membership.templateLevel === 1 &&
            props.totalBuyQuantity >= 200 &&
            props.mode === 0 &&
            !isEN()
          ) {
            exceedingNumTip.value.open()
            return
          }
          emit('commit')
        }
      })
    }
  })
}

// 接受不良风险提示
const acceptArgeement = async () => {
  const textData = termModalRef.value.fetchText(term.value.fileUrl)

  const adverRisk = `
    ご注文の際に検品オプションを選択頂いた場合、当社の検品標準により検品を行います。
    不良品と判断される場合、ご指定頂いた不良品の対応方式に従って「返品返金」OR 「交換」を行います。
    但し、当社で不良品と判断されたものの、販売サイトまたはショップに対して返品できないため返品不可になる場合がありますので予めご了承下さい。
    （発生確率が約0~0.1%程度）

    その場合、当該不良品が返品不可不良品となります。

    返品不可不良品に対して、【在庫管理】メニュー で廃棄処理を依頼するか、
    お客様の許可を得た上で、良品としてお客様に配送するか、
    いずれかの処理方法を選択することができます。

    当社で廃棄処理を依頼する場合、お客様において当該商品の所有権が放棄されたものとみなし、ショップから商品代金の返金はなされませんので予めご了承ください。

    ※以下のいずれかに該当する場合は返品不可不良品となる可能性があります。
    ・お客様の検品要求が常に厳しく、ショップ側が不良品と認められない場合
    ・ショップ側は7日間無条件返品サービスを提供してない場合
    ・お客様都合により返品受付期間内（商品到着後7日以内）に返品要求を提出してない場合※返品不可不良品の発生を回避する方法については、下記の内容をご参照下さい。
      ${isD2C()
      ? 'https://s.theckb.com/d2c/article/2/78'
      : 'https://s.theckb.com/b2b/article/2/78'
    }
    `

  try {
    await agreeTerm({
      termId: term.value.termId
    })

    const res = await updateProductRisk({
      confirmationStyle: 1, // 1： 下单  2：API订单  3：邮箱
      version: '1.0' + '-' + textData.data
    })

    if (res.code === 0) {
    }
  } catch (error) { }

  updateProductRisk({
    confirmationStyle: 1, // 1： 下单  2：API订单  3：邮箱
    version: '1.0' + '-' + textData.data
  }).then((res: any) => {
    if (res.code === '0') {
      argeeVisiable.value = false
      onagree()
      getUser(token).then((res: any) => {
        // 判断是否是经济舱会员并且下单数量超过200件，并且是采购到库存的订单，引导用户开通标准舱会员
        if (
          res.data.membership.templateLevel === 1 &&
          props.totalBuyQuantity >= 200 &&
          props.mode === 0
        ) {
          exceedingNumTip.value.open()
          return
        }
        emit('commit')
      })
    }
  })
}

const onagree = () => {
  termModalRef.value.close()
}

return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (__props.showNum)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createTextVNode(_toDisplayString(t('订单商品总数量')) + "：", 1),
            _createElementVNode("span", null, _toDisplayString(__props.totalBuyQuantity) + " " + _toDisplayString(t('件')), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createTextVNode(_toDisplayString(t('订单商品代金(预估)')) + "：", 1),
        _createElementVNode("span", null, _toDisplayString(_unref(pdtRmb)) + " " + _toDisplayString(t('元')), 1)
      ]),
      (__props.confirm && __props.mode === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(`${t('本次实付商品代金')}(${_unref(curPdRate)}%)`), 1),
            _hoisted_6,
            _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(curPdtRmb)) + " " + _toDisplayString(t('元')), 1)
          ]))
        : _createCommentVNode("", true),
      (__props.confirm && __props.mode === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("span", _hoisted_9, _toDisplayString(`${t('待支付商品代金尾款')}(${_unref(falPdRate)}%)`), 1),
            _hoisted_10,
            _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(falPdRmb)) + " " + _toDisplayString(t('元')), 1)
          ]))
        : _createCommentVNode("", true),
      (__props.combineAdditionTotalFee)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createTextVNode(_toDisplayString(t('组合返工费用')) + " ", 1),
            _createVNode(_component_el_tooltip, {
              effect: "light",
              placement: "top",
              "popper-class": "tool-tip-no-border"
            }, {
              content: _withCtx(() => [
                _createElementVNode("div", {
                  style: {"max-width":"200px"},
                  innerHTML: t('成品区库存重组需收取组合费用')
                }, null, 8, _hoisted_13)
              ]),
              default: _withCtx(() => [
                _hoisted_14
              ]),
              _: 1
            }),
            _hoisted_15,
            _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(getTrueNumber)(__props.combineAdditionTotalFee)) + " " + _toDisplayString(t('元')), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_17, [
        _createTextVNode(_toDisplayString(t('订单商品附加项(预估)')) + " ", 1),
        _createVNode(_component_el_tooltip, {
          "popper-class": "style-tip-icon-width",
          effect: "light",
          content: t('此商品附加项只对该订单中需采购的商品生效，对库存商品不生效')
        }, {
          default: _withCtx(() => [
            _hoisted_18
          ]),
          _: 1
        }, 8, ["content"]),
        _hoisted_19,
        _createElementVNode("span", null, _toDisplayString(_unref(adtRmb)) + " " + _toDisplayString(t('元')), 1)
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createTextVNode(_toDisplayString(t('订单本次实付金额(预估)')) + "：", 1),
        _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(rmb)) + " " + _toDisplayString(t('元')), 1),
        _createElementVNode("span", _hoisted_22, "(" + _toDisplayString(_unref(formatMoneyDirection)(_unref(yan))) + " )", 1)
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, _toDisplayString(t(
            '提示：此金额为预估报价，您下单后，该部分金额将会被冻结。等到该订单采购处理全部完成后，我们会自动解冻这部分金额，并按照实际产生的金额进行扣费。实际扣费详情您可以后续在资金明细页面或订单详情页面查看。'
          )), 1)
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("span", null, _toDisplayString(t('当前余额')) + "：", 1),
        _createElementVNode("span", null, _toDisplayString(rest.value) + " " + _toDisplayString(t('元')), 1)
      ])
    ]),
    (!__props.confirm)
      ? (_openBlock(), _createBlock(WatchSticky, {
          key: 0,
          modelValue: isSticky.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((isSticky).value = $event))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(["flex-ter float", { sticky: isSticky.value, numberExceedPadding: __props.isNumberExceed }])
            }, [
              (__props.isNumberExceed && __props.mode)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _createVNode(_component_el_checkbox, {
                      modelValue: isAgree.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isAgree).value = $event)),
                      style: {"font-size":"12px"}
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          innerHTML: t('同意一个包裹无法装下商品时，THE CKB将为您拆成多个包裹进行发货'),
                          style: {"line-height":"16px"}
                        }, null, 8, _hoisted_27)
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_Transition, { name: "el-fade-in" }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, _toDisplayString(t('订单商品总数量')) + "：" + _toDisplayString(__props.totalBuyQuantity) + _toDisplayString(t('件')), 1),
                    _createElementVNode("div", null, [
                      _createElementVNode("span", null, _toDisplayString(t('订单预估总价')) + "：", 1),
                      _createElementVNode("span", _hoisted_30, _toDisplayString(_unref(rmb)) + _toDisplayString(t('元')), 1),
                      _createElementVNode("span", _hoisted_31, "(" + _toDisplayString(_unref(formatMoneyDirection)(_unref(yan), )) + ")", 1)
                    ])
                  ], 512), [
                    [_vShow, isSticky.value]
                  ])
                ]),
                _: 1
              }),
              (!__props.hiddenGroupBtn && _unref(isJA)())
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 1,
                    type: "primary",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('createGroup')))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(t('创建组合商品')), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_el_button, {
                type: "primary",
                class: "dark",
                onClick: submitOrder,
                disabled: __props.disabled || (!isAgree.value && __props.isNumberExceed)
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(t('提交订单')), 1)
                ]),
                _: 1
              }, 8, ["disabled"])
            ], 2)
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_32, [
          _createVNode(_component_el_button, {
            type: "primary",
            class: "dark",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (emit('commit'))),
            disabled: _unref(disabledBtn)
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(t('确认并支付')), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ])),
    _createVNode(OpenMember, {
      ref: (_value, _refs) => {
        _refs['openMemberRef'] = _value
        openMemberRef.value = _value
      }
    }, null, 512),
    _createVNode(ExceedingNumTip, {
      ref: (_value, _refs) => {
        _refs['exceedingNumTip'] = _value
        exceedingNumTip.value = _value
      },
      totalBuyQuantity: __props.totalBuyQuantity,
      onCloseExceeding: _cache[4] || (_cache[4] = ($event: any) => (emit('commit')))
    }, null, 8, ["totalBuyQuantity"]),
    _createVNode(TermModal, {
      ref: (_value, _refs) => {
        _refs['termModalRef'] = _value
        termModalRef.value = _value
      },
      title: t('次转正提醒'),
      fileUrl: term.value?.fileUrl,
      disableBtn: true,
      timer: true,
      onagree: onagree,
      "ondis-agree": acceptArgeement
    }, null, 8, ["title", "fileUrl"])
  ], 64))
}
}

})